import baseAPI from "@/api/base";
import { RequestEnrichment } from "@/dtos/Fullenrich.dto";
import { REQUEST_ENRICHMENT_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

class Fullenrich {
  static requestEnrichment = async (
    requestEnrichment: RequestEnrichment
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REQUEST_ENRICHMENT_URL, {
      ...requestEnrichment,
    });
    return response;
  };
}

export default Fullenrich;
